module.exports = __webpack_public_path__ + "img/advance-4.55e18f14.png";